export default __webpack_public_path__ + "static/media/left-aligned-big-wave.42775416.svg";